import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import * as CubiqTS from "shared/cubiq-model-multi-asset";

const PENDING_MAP: WeakMap<CubiqTS.OpsIntEventImpl, Array<[string, Set<string>]>> = new WeakMap();

export namespace OpsIntEventPrivatizer {
  export function setPending(
    event: CubiqTS.OpsIntEventImpl,
    pendingArgs: Array<[string, Set<string>]>,
  ): object {
    if (event instanceof CubiqTS.OpsIntEventImpl) {
      PENDING_MAP.set(event, pendingArgs);
    }

    return event;
  }

  export function hasPending(event: CubiqTS.OpsIntEventImpl): boolean {
    return PENDING_MAP.has(event);
  }

  export function complete(event: CubiqTS.OpsIntEventImpl): CubiqTS.OpsIntEventImpl {
    if (
      event != null &&
      event instanceof CubiqTS.OpsIntEventImpl &&
      event.info != null &&
      event.info instanceof CubiqTS.OpsExcInfoImpl
    ) {
      let info = event.info;
      let serialize = false;
      const pendingArgs = PENDING_MAP.get(event);
      const processorFn = (message) => {
        try {
          let jsonObj = JSON.parse(message);
          serialize = false;

          if (Array.isArray(jsonObj.args)) {
            for (let [pendingLabel, pendingSet] of pendingArgs) {
              jsonObj.args.forEach((arg, i, array) => {
                if (pendingSet.has(arg)) {
                  array[i] = pendingLabel;
                  serialize = true;
                }
              });
            }
            if (serialize) {
              return JSON.stringify(jsonObj);
            } else {
              return message;
            }
          }
        } catch (e) {
          logger.out.warn(`${this.constructor.name} json serialization failure`);
        }
        return message;
      };

      if (
        info.transactionData != null &&
        info.transactionData instanceof CubiqTS.ErrorsImpl &&
        Array.isArray(info.transactionData.errorMessages)
      ) {
        info.transactionData.errorMessages = info.transactionData.errorMessages.map(processorFn);
      }

      if (info.opsException != null && info.opsException instanceof CubiqTS.OpsExcRecordImpl) {
        if (
          info.opsException.reasonTxt != null &&
          info.opsException.reasonTxt instanceof CubiqTS.ErrorsImpl &&
          Array.isArray(info.opsException.reasonTxt.errorMessages)
        ) {
          info.opsException.reasonTxt.errorMessages =
            info.opsException.reasonTxt.errorMessages.map(processorFn);
        }

        if (
          info.opsException.descriptionTxt != null &&
          info.opsException.descriptionTxt instanceof CubiqTS.ErrorsImpl &&
          Array.isArray(info.opsException.descriptionTxt.errorMessages)
        ) {
          info.opsException.descriptionTxt.errorMessages =
            info.opsException.descriptionTxt.errorMessages.map(processorFn);
        }
      }

      event.info = info;

      PENDING_MAP.delete(event);
    }
    return event;
  }
}
